var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79014 15.7899C5.8831 15.8836 5.9937 15.958 6.11556 16.0088C6.23742 16.0596 6.36812 16.0857 6.50014 16.0857C6.63215 16.0857 6.76285 16.0596 6.88471 16.0088C7.00657 15.958 7.11717 15.8836 7.21014 15.7899L11.7901 11.2099C11.8831 11.1162 11.9937 11.0418 12.1156 10.991C12.2374 10.9402 12.3681 10.9141 12.5001 10.9141C12.6321 10.9141 12.7629 10.9402 12.8847 10.991C13.0066 11.0418 13.1172 11.1162 13.2101 11.2099L17.7901 15.7899C17.8831 15.8836 17.9937 15.958 18.1156 16.0088C18.2374 16.0596 18.3681 16.0857 18.5001 16.0857C18.6322 16.0857 18.7629 16.0596 18.8847 16.0088C19.0066 15.958 19.1172 15.8836 19.2101 15.7899C19.3964 15.6025 19.5009 15.3491 19.5009 15.0849C19.5009 14.8207 19.3964 14.5673 19.2101 14.3799L14.6201 9.78991C14.0576 9.22811 13.2951 8.91255 12.5001 8.91255C11.7051 8.91255 10.9426 9.22811 10.3801 9.78991L5.79014 14.3799C5.60389 14.5673 5.49934 14.8207 5.49934 15.0849C5.49934 15.3491 5.60389 15.6025 5.79014 15.7899Z",
    fill: "#98A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretup);
export default __webpack_public_path__ + "static/media/caretup.3722bbef749863c38cded9aa5791a222.svg";
export { ForwardRef as ReactComponent };